export enum NormalRangeListEnum {
    Normal = 1,
    AbnormalHigh = 2,
    Panic = 3,
    Absurd = 4,
    AbnormalLow = 5,
}
